// src/pages/EditServicePage.js
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import ServiceForm from '../components/ServiceForm';
import { Typography, Container, CircularProgress } from '@mui/material';

const EditServicePage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [initialValues, setInitialValues] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchService = async () => {
      try {
        const res = await axios.get(`http://localhost:3000/services/${id}`);
        const service = res.data;
        setInitialValues({
          title: service.title,
          description: service.description,
          price: service.price,
          category: service.category,
        });
      } catch (error) {
        alert('No se pudo cargar el servicio');
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchService();
  }, [id]);

  const handleUpdate = async (values) => {
    try {
      await axios.put(`http://localhost:3000/services/${id}`, values);
      alert('Servicio actualizado correctamente');
      navigate('/services');
    } catch (error) {
      alert('Error al actualizar el servicio');
      console.error(error);
    }
  };

  if (loading || !initialValues) return <CircularProgress />;

  return (
    <Container sx={{ mt: 4 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>Editar Servicio</Typography>
      <ServiceForm initialValues={initialValues} onSubmit={handleUpdate} />
    </Container>
  );
};

export default EditServicePage;